import localFont from "@next/font/local";
import type { ReactNode } from "react";

export const font = localFont({
  src: [
    { path: "./font/NotoSansCJKjp-Bold.otf", weight: " 700" },
    { path: "./font/NotoSansCJKjp-Medium.otf", weight: " 500" },
    { path: "./font/NotoSansCJKjp-Regular.otf", weight: " 400" },
    { path: "./font/NotoSansCJKjp-Light.otf", weight: " 200" },
  ],
});

export const LocalFontProvider = ({ children }: { children: ReactNode }) => {
  return <div className={font.className}>{children}</div>;
};
